import React from "react";
import "./Strategies.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartLine,
  faBullseye,
  faLayerGroup,
  faPenRuler,
  faGear,
  faArrowTrendUp,
} from "@fortawesome/free-solid-svg-icons";

const strategyItems = [
  {
    icon: faChartLine,
    title: "Research & Analysis",
    description:
      "We start by understanding your business, audience, and current performance. This helps us identify real growth opportunities instead of relying on assumptions.",
  },
  {
    icon: faBullseye,
    title: "Positioning & Messaging",
    description:
      "We refine how your brand communicates so visitors immediately understand your value and feel confident choosing you.",
  },
  {
    icon: faLayerGroup,
    title: "Structured Growth Plan",
    description:
      "We design a clear system that connects traffic, content, and conversions—so every part supports the same goal.",
  },
  {
    icon: faPenRuler,
    title: "Experience & Content Design",
    description:
      "Pages, visuals, and copy are designed to guide users naturally, reduce friction, and answer questions before they ask.",
  },
  {
    icon: faGear,
    title: "Automation & Tools",
    description:
      "We integrate forms, tracking, and follow-ups to ensure every lead is captured, tracked, and handled consistently.",
  },
  {
    icon: faArrowTrendUp,
    title: "Testing & Improvement",
    description:
      "After launch, we monitor performance and continuously improve so results grow steadily over time.",
  },
];

const Strategies = () => {
  return (
    <section className="sg-about" aria-label="Our strategy">
      <div className="sg-about-wrap">
        {/* Header */}
        <header className="sg-about-head">
          <span className="sg-about-kicker">Our Strategy</span>
          <h2>Simple, structured, and focused on results</h2>
          <p>
            We follow a clear process that removes confusion, aligns every
            decision with your goals, and builds long-term growth—not quick
            hacks.
          </p>
        </header>

        {/* Grid */}
        <div className="sg-about-grid">
          {strategyItems.map((item) => (
            <article className="sg-about-card" key={item.title}>
              <div className="sg-about-icon">
                <FontAwesomeIcon icon={item.icon} />
              </div>

              <div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Strategies;
